/* Product Detail Page Inline ATC: sticky add to cart bar.
 *
 * The real add to cart button stays next to the quantity selector. This bar
 * shows only after the shopper scrolls past that row, and a click on it runs
 * the real button, so variant, quantity, selling plan and the cart drawer all
 * use the theme's own product form.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.pdpInlineAtcReady) return;
    var bar = root.querySelector('[data-pdp-inline-sticky]');
    var form = root.querySelector('product-form form[data-type="add-to-cart-form"]');
    var row = form && form.querySelector('.pdp-qty-btns');
    var realBtn = row && row.querySelector('.pdp-btn .submit_btn');
    if (!bar || !row || !realBtn) return;
    root.dataset.pdpInlineAtcReady = 'true';

    var dummyBtn = row.querySelector('.pdp-btn .dummy_btn');
    var barBtn = bar.querySelector('[data-pdp-inline-sticky-btn]');
    var barText = bar.querySelector('[data-pdp-inline-sticky-text]');

    function realIsUsable() {
      return !realBtn.classList.contains('d-none') && !realBtn.disabled && !realBtn.hasAttribute('disabled');
    }

    function sync() {
      var useDummy = realBtn.classList.contains('d-none') && dummyBtn && !dummyBtn.classList.contains('d-none');
      var source = useDummy ? dummyBtn : realBtn;
      var text = source.querySelector('.add-text');
      if (text && barText) barText.textContent = text.textContent.trim();
      var off = !realIsUsable();
      barBtn.disabled = off;
      barBtn.classList.toggle('disabled', off);
      barBtn.classList.toggle('loading', realBtn.classList.contains('loading'));
    }

    barBtn.addEventListener('click', function (event) {
      event.preventDefault();
      if (!realIsUsable()) return;
      realBtn.click();
    });

    var observer = new MutationObserver(sync);
    observer.observe(row, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled'] });
    sync();

    // Read the row position on scroll: an observer misses a jump from below
    // the row to above it (or back) when the row never enters the viewport.
    var ticking = false;
    function place() {
      ticking = false;
      if (!row.isConnected) {
        window.removeEventListener('scroll', queue);
        window.removeEventListener('resize', queue);
        return;
      }
      var rect = row.getBoundingClientRect();
      bar.hidden = rect.height === 0 || rect.bottom > 0;
    }
    function queue() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(place);
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    place();
  }

  // A preview opened with ?view=<template> keeps that template when the shopper
  // switches experience (Focus / Relax / Sleep). Products assigned to this
  // template need no help: the theme fetches their assigned template.
  var previewView = new URLSearchParams(window.location.search).get('view');
  if (previewView && /^[a-z0-9_-]+$/i.test(previewView) && window.fetch && !window.fetch.pdpInlineAtcView) {
    var nativeFetch = window.fetch;
    var viewFetch = function (input, init) {
      if (typeof input === 'string' && /^\/products\/[a-z0-9_-]+$/i.test(input)) {
        input = input + '?view=' + encodeURIComponent(previewView);
      }
      return nativeFetch.call(this, input, init);
    };
    viewFetch.pdpInlineAtcView = true;
    window.fetch = viewFetch;
  }

  function boot() {
    document.querySelectorAll('[data-pdp-inline-atc]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('productSwitched', boot);
})();
